import _ from 'lodash';
import moment from 'moment';
// eslint-disable-next-line import/no-unresolved
import { dynamicSort } from '@commonClient2/services/sort';
import { UkgDateFormat } from '../../Enums';
import { getProfileStatusLabel } from '../../Enums/Helpers/LabellingHelper';
import DateFormatService from '../../services/DateFormatService';

/** @type {(bid: ManagerAppData.IAuditableBid) => string} */
export const searchableAuditBid = (bid) => `${bid.name}
        |${bid.description}
        |${getProfileStatusLabel(bid.status)}
        |${DateFormatService.formatDateOrEmpty(
        bid.statusDate,
        UkgDateFormat.LongDateTime,
    )}
        `.toLocaleLowerCase();

/**
 * @param {ManagerAppData.IAuditableBid[]} filteredData
 * @param {Function} setFilteredData
 * @param {string} dataKey
 * @param {string} sortType
 */
export const handleSort = (filteredData, setFilteredData, dataKey, sortType) => {
    /** @type {ManagerAppData.IAuditableBid[]} */
    let sortedFilteredData = [];
    const dataWithTranslatedLabels = filteredData.map((x) => ({
        ...x,
        statusLabel: getProfileStatusLabel(x.status),
        statusDateLabel: DateFormatService.formatDateOrEmpty(
            x.statusDate,
            UkgDateFormat.LongDateTime,
        ),
    }));
    const dynamicSortOrder = sortType === 'desc' ? '-' : '';
    const order = sortType === 'desc' ? -1 : 1;
    // eslint-disable-next-line max-len
    const nullCheckingDateSort = (/** @type {string} */ propName) => (/** @type {ManagerAppData.IAuditableBid} */ obj1, /** @type {ManagerAppData.IAuditableBid} */ obj2) => {
        const a = _.get(obj1, propName, null);
        const b = _.get(obj2, propName, null);
        if (!a && !b) {
            return 0;
        }
        if (!a) {
            return order * -1;
        }
        if (!b) {
            return order * 1;
        }
        const momentA = moment(a);
        const momentB = moment(b);
        // eslint-disable-next-line no-nested-ternary
        return order * ((momentA < momentB) ? -1 : (momentA > momentB) ? 1 : 0);
    };
    switch (dataKey) {
        case 'name':
            sortedFilteredData = dataWithTranslatedLabels.sort(
                dynamicSort(`${dynamicSortOrder}name`),
            );
            break;
        case 'description':
            sortedFilteredData = dataWithTranslatedLabels.sort(
                dynamicSort(`${dynamicSortOrder}description`),
            );
            break;
        case 'status':
            sortedFilteredData = dataWithTranslatedLabels.sort(
                dynamicSort(`${dynamicSortOrder}statusLabel`),
            );
            break;
        case 'statusDate':
            sortedFilteredData = dataWithTranslatedLabels.sort(
                nullCheckingDateSort('statusDateLabel'),
            );
            break;
        default:
            break;
    }
    setFilteredData(_.cloneDeep(sortedFilteredData));
};
